<template>
  <div class="proItem">
    <div class="itemIcon">
      <div class="iconInner" :style="{width:itemData.iconSize,height:itemData.iconSize}">
        <div class="iconCenter"></div>
      </div>
    </div>
    <div class="itemContent">
      <div class="date">{{itemData.date}}</div>
      <div class="text" v-for="(item,index) in itemData.text" :key="index">{{item}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tabItem",
  props:['itemData'],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.proItem {
  display: flex;
  align-items: center;
  margin-left: -15px;
  padding: 24px 0;
  .itemIcon {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    .iconInner {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      background: #d5262b;
      padding: 2px;
      box-sizing: border-box;
      .iconCenter {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid #fff;
        box-sizing: border-box;
      }
    }
  }
  .itemContent {
    margin-left: 40px;
    color: #333;
    .date {
      font-size: 20px;
      line-height: 20px;
    }
    .text {
      font-size: 16px;
      line-height: 16px;
      margin-top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutUs/components/proItem.vue